module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaCargador-573fe5cd.png";